import React from 'react';
import { ButtonElement } from '../../../../components/ButtonElement';
import ModalWindow from '../../../../components/ModalWindow';
export default class ConfirmationModal extends React.Component {
	renderConfirmMessage = () => {
		return <>{this.props.children}</>;
	};
	render() {
		return (
			<ModalWindow
				visible={this.props.visible}
				onCancel={!this.props.loading && this.props.onCancel}
				title={this.props.title}
				className=''
				footer={
					<>
						<ButtonElement
							onClick={this.props.onCancel}
							children={this.props.cancelButtonLabel || 'Cancel'}
							type={this.props.isConfirmMessage ? 'primary' : ''}
							disabled={this.props.loading}
						/>

						<ButtonElement
							onClick={this.props.onOk}
							type={!this.props.isConfirmMessage ? 'primary' : ''}
							children={
								this.props.confirmButtonLabel || 'Confirm'
							}
							loading={this.props.loading}
							disabled={this.props.isDisable}
						/>
					</>
				}>
				{this.renderConfirmMessage()}
			</ModalWindow>
		);
	}
}
